import { PipeTransform } from '@angular/core';
var BadgePipe = /** @class */ (function () {
    function BadgePipe() {
    }
    BadgePipe.prototype.transform = function (value) {
        if (!value) {
            return '';
        }
        return value > 9
            ? '+9'
            : value.toString();
    };
    return BadgePipe;
}());
export { BadgePipe };
